<template>
  <div class="loginBg">
    <div class="login-box">
      <div class="head">
        <!-- <img src="../assets/images/logo.png" alt=""> -->
        <div class="logo-img">{{ loginTitle }}</div>
      </div>
      <el-form
        class="login-form"
        :model="loginForm"
        :rules="rules"
        ref="loginForm"
      >
        <el-form-item prop="userCode">
          <el-input
            v-model="loginForm.userCode"
            placeholder="请输入账号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.passWord"
            type="password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-button type="primary" round :loading="loading" @click="login"
          >登录</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import { datasApi } from "@/api/dataApi";
export default {
  name: "Login",
  computed: {
    loginTitle() {
      return config.loginTitle;
    }
  },
  data() {
    return {
      loading: false,
      loginForm: {
        userCode: "",
        passWord: ""
      },
      rules: {
        userCode: [
          { required: true, message: "账号不能为空", trigger: "blur" }
        ],
        passWord: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      }
    };
  },
  methods: {
    //登录
    login() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          //登录请求
          this.loginRequest();
          // sessionStorage.setItem("isLogin", 1);
          // sessionStorage.setItem("userInfo", JSON.stringify({
          //   realName: '东湖技术开发区'
          // }));
          // this.$router.push({ path: "/dashboard" });
        } else {
          return false;
        }
      });
    },
    loginRequest() {
      datasApi
        .Login(this.loginForm)
        .then(res => {
          this.loading = false;
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success"
            });
            sessionStorage.setItem("isLogin", 1);
            sessionStorage.setItem("userInfo", JSON.stringify(res.data));
            this.$router.push({ path: "/dashboard" });
          } else if(res.code == 202 || res.code == 2002) {
            this.$message.error(res.msg);
          }
          else {
            this.$message.error("用户名或密码错误");
          }
        })
        .catch(err => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.loginBg {
  width: 100%;
  height: 100%;
  background-image: url("../assets/images/loginBg.jpg");
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-box {
  width: 440px;
  height: 400px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.head {
  height: 150px;
  width: 100%;
  background-image: linear-gradient(126deg, #201b4f 15%, #0b0930 100%);
  background-color: #201b4f;
  box-shadow: 0 2px 7px 0 #211b4f;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-img {
  width: 220px;
  height: 36px;
  // background-image: url('../assets/images/hn_logo.jpg');
  font-size: 17px;
  color: white;
  text-align: center;
}
.login-form {
  display: flex;
  flex-direction: column;
  padding: 40px;
}
.group {
  margin-bottom: 20px;
  width: 100%;
}
.group input {
  height: 40px;
  width: calc(100% - 20px);
  padding: 0 10px;
  border: 1px solid #e5e5e5;
}
.el-button {
  font-size: 16px;
}
</style>
